import React, { PureComponent } from 'react';

import Button from '~/kits/general/scripts/components/Button';
import StaticMap from '~/kits/general/scripts/components/StaticMap';
import HalfDonut from '~/kits/general/scripts/components/HalfDonut';
import { numberFormat } from '~/core/scripts/utils';
import Legend from '~/core/scripts/components/Legend';

import './ComparisonMap.styl';

class ComparisonMap extends PureComponent {
  state = {
    dataIndex: 1
  }

  onButtonClick(evt, dataIndex) {
    evt.stopPropagation();
    this.setState({ dataIndex });
  }

  render() {
    const {
      title, text, mapData, maxLegendValue,
      colorScale, donutData = false, swoopies = []
    } = this.props;

    const { dataIndex } = this.state;

    return (
      <div className="comparisonmap">
        <div className="slide-title">{title}</div>
        <div className="slide-text">{text}</div>
        <div className="comparisonmap__vis">
          {donutData && (
            <div className="comparisonmap__donut">
              <HalfDonut data={donutData[dataIndex]} />
              <div className="slide-share donut-share">Anteil: <strong>{numberFormat(donutData[dataIndex][0].relSeats, 1)} %</strong></div>
            </div>
          )}
          <StaticMap data={mapData[dataIndex]} colorScale={colorScale} swoopies={swoopies} maxLegendValue={maxLegendValue} />
        </div>
        <Legend
          minLabel={`${colorScale.values[0]} %` || 'min'}
          maxLabel={`${maxLegendValue} %` || 'max'}
          colors={colorScale.colors}
        />
        <div className="comparisonmap__controls btn-group comparison">
          <Button
            label="2014"
            isActive={dataIndex === 0}
            onClick={(evt) => this.onButtonClick(evt, 0)}
          />
          <Button
            label="2019"
            isActive={dataIndex === 1}
            onClick={(evt) => this.onButtonClick(evt, 1)}
          />
        </div>
      </div>
    );
  }
}

export default ComparisonMap;
